import React, { useContext } from "react";

import CookieConsent from "react-cookie-consent";
import { ThemeContext } from "styled-components";

import Button from "../../shared/components/Button/Button";

function CookiePolicy() {
  const theme = useContext(ThemeContext);

  return (
    <CookieConsent
      buttonClasses="px-4 text-white"
      ButtonComponent={Button}
      buttonStyle={{
        backgroundColor: theme.primaryColor,
        fontSize: "1rem",
      }}
      containerClasses="border-top"
      contentClasses="fw-bold"
      contentStyle={{ fontSize: "1rem" }}
      location="bottom"
      style={{ background: "white", color: "#212529" }}
    >
      This website uses cookies to ensure you get the best experience on our
      website.
    </CookieConsent>
  );
}

export default CookiePolicy;
